<!-- Avoid that horrible console error -->
<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>

<script lang="ts">
	// eslint-disable vue/valid-template-root
	import { isPrerender } from '@cognitoforms/utils/utilities';
	import { getActiveSession } from '@cognitoforms/api/services/session';
	import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
	import { defineComponent, watch } from 'vue';
	import { useRoute } from 'vue-router/composables';
	import { isPlanAndBillingDocument } from 'src/utilities/plan-and-billing-isolation';

	// Only initialize pendo if it has not already been initialized and if the api key is set
	getActiveSession().then(session => {
		if (!isPrerender() && !window.pendo && !isPlanAndBillingDocument() && CognitoConfiguration.PendoApiKey && session.isAuthenticated && !session.isGuestSession) {
			(function (apiKey) {
				(function (p, e, n, d, o) {
					let w, x;
					o = p[d] = p[d] || {};
					o._q = [];
					const v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
					for (w = 0, x = v.length; w < x; ++w) (function (m) {
						o[m] = o[m] || function () {
							o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
						};
					})(v[w]);
					const y = e.createElement(n);
					y.async = !0;
					y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
					const z = e.getElementsByTagName(n)[0];
					z.parentNode.insertBefore(y, z);
				})(window, document, 'script', 'pendo');
			})(CognitoConfiguration.PendoApiKey);

			window.pendo.initialize({ visitor: {}, account: {} });
		}
	}).catch(() => {});

	export default defineComponent({
		name: 'CPendo',
		setup() {
			const route = useRoute();

			// Only record a page visit if pendo is initialized and we are not prerendering
			watch(() => route.fullPath, () => {
				if (!isPrerender() && window.pendo) {
					window.setTimeout(() => {
						window.pendo.initialize({ visitor: {}, account: {} });
					}, 3000);
				}
			});

			return {
				pendo: window.pendo
			};
		}
	});
</script>

<style lang="scss" src="@cognitoforms/styles/app/_pendo.scss"></style>
